import type { ButtonProps } from '@jouzen/ecom-components/v3/Button';
import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

interface SizeGuideModalStepCtaProps extends Omit<ButtonProps, 'children'> {
  readonly label: MessageKey;
}

export interface SizeGuideModalStepProps {
  readonly content: MessageKey[];
  readonly cta?: SizeGuideModalStepCtaProps;
  readonly index: number;
  readonly title: MessageKey;
}

const SizingGuideModalStepCta = ({
  label,
  ...props
}: SizeGuideModalStepCtaProps) => {
  return (
    <Button className="mt-5" data-cy="size-guide-modal-step-cta" {...props}>
      <RichText messageKey={label} />
    </Button>
  );
};

const SizeGuideModalStep = ({
  content,
  cta,
  index,
  title,
}: SizeGuideModalStepProps) => {
  return (
    <li className="mb-12 last:mb-0" data-cy="size-guide-modal-step">
      <Typography
        className="mb-5 text-heading-lg leading-tighter"
        data-cy="size-guide-modal-step-title"
        Element="h3"
        weight="light"
      >
        <span aria-hidden="true" className="mr-3 inline-block">
          {index + 1}.
        </span>
        <span>
          <RichText messageKey={title} />
        </span>
      </Typography>
      {content.map((key) => (
        <Typography
          className="text-sm"
          data-cy="size-guide-modal-step-content"
          key={key}
        >
          <RichText messageKey={key} />
        </Typography>
      ))}
      {cta && <SizingGuideModalStepCta {...cta} />}
    </li>
  );
};

export default SizeGuideModalStep;
